import React, { Component } from 'react'
class Loading extends Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }
    render() {
        return (
            <div className="full_width">
                <div className="full_width_inner">
                    <div className="vc_row wpb_row section vc_row-fluid  grid_section" style={{ backgroundColor: '#ffffff', paddingTop: '87px', paddingBottom: '80px', textAlign: 'left' }}>
                        <div className=" section_inner clearfix">
                            <div className="section_inner_margin clearfix">
                                <div className="wpb_column vc_column_container vc_col-sm-12">
                                    <div className="vc_column-inner">
                                        <div className="wpb_wrapper">
                                            <div className="wpb_text_column wpb_content_element ">
                                                <div className="wpb_wrapper">
                                                    <div className="loader"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}
export default Loading